import { render, staticRenderFns } from "./HorizontalImgText.vue?vue&type=template&id=2b8f675c&scoped=true"
import script from "./HorizontalImgText.vue?vue&type=script&lang=js"
export * from "./HorizontalImgText.vue?vue&type=script&lang=js"
import style0 from "./HorizontalImgText.vue?vue&type=style&index=0&id=2b8f675c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f675c",
  null
  
)

export default component.exports